<script lang="ts">
    import { captureError } from '@otto-ec/global-resources/apm';
    import type { Result } from '@shared/types/utilities.ts';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import TileListPageController from '@tilelist/components/tile-list-page/TileListPageController.svelte';
    import TileListPageError from '@tilelist/components/tile-list-page/TileListPageError.svelte';

    type Props = {
        result: Result<TileListInitialSession>;
    };

    const { result }: Props = $props();

    $effect(() => {
        if (result.state === 'error') {
            captureError(new Error('No page data'), { team: 'reptile', service: 'dundee' }, { type: 'initial' });
        }
    });
</script>

{#if result.state === 'error'}
    <TileListPageError />
{:else}
    <TileListPageController initialSession={result.payload} />
{/if}
